import React, { useEffect, useReducer, useState } from 'react'
import { AppContext } from './AppContext'
import AppReducer from './AppReducer'
import jwt from 'jwt-decode'
import { getUserData } from '../api/Login'
import HTTP from '../http-common'

const State = (props) => {

	const initialState = {
		auth: null,
		user: null,
		companies: null,
		defaultValues: {
			vehicle: null,
        	depot: null,
			typeService: []
		}
	}

	const [state, dispatch] = useReducer(AppReducer, initialState)
	const [loading, setLoading] = useState(true)

	const hydrate = async () => {
		try {
			const res = await getUserData()
			const data = { ...res.data }
			
			if (data.token) {
				setAuth(data.token)
			} else if (data.uuid_field || data.id) {
				// Si no hay token pero hay datos de usuario, reconstruimos el objeto auth
				// para que el router permita el acceso.
				setAuth({
					user_uuid: data.uuid_field || data.id,
					company_id: data.company?.id
				})
			}
			
			if (data.companies) {
				setCompanies(data.companies)
			}

			if (data.company?.web_config?.default_values_pwa) {
				const { vehicle, depot, type_service } = data.company.web_config.default_values_pwa
				setDefaultVal({ 
					vehicle: JSON.stringify(vehicle) === '{}' ? null : vehicle,
					depot: JSON.stringify(vehicle) === '{}' ? null : depot,
					typeService: type_service
				})
			}

			if (data.company?.id) {
				HTTP.setCompanyId(data.company.id)
			}

			delete data.companies
			setUser(data)

			return data
		} catch (error) {
			console.log("Not logged in or session expired")
			logout_local()
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		hydrate();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const setAuth = (authInput) => {
		let auth = null

		if (typeof authInput === 'string' && authInput) {
			HTTP.setToken(authInput)
			auth = jwt(authInput)
		} else if (authInput && typeof authInput === 'object') {
			auth = authInput
		}

		if (auth?.company_id) {
			HTTP.setCompanyId(auth.company_id)
		}

		dispatch({
			type: 'SET_AUTH',
			payload: auth
		})
	}

	const setCsrfToken = (csrfToken) => {
		dispatch({
			type: 'SET_CSRF',
			payload: csrfToken
		})
	}

	const setUser = (data) => {
		dispatch({
			type: 'SET_USER',
			payload: data
		})
	}

	const setCompanies = (data) => {
		dispatch({
			type: 'SET_COMPANIES',
			payload: data
		})
	}

	const setDefaultVal = (data) => {
		dispatch({
			type: 'SET_DEFAULT',
			payload: data
		})
	}

	const logout_local = () => {
		dispatch({ type: 'LOGOUT' })
		HTTP.setCompanyId(null)
		HTTP.setToken(null)
		sessionStorage.clear()
		localStorage.clear()
	}



	return (
		<AppContext.Provider value={{
			auth: state.auth,
			user: state.user,
			companies: state.companies,
			defaultVal: state.defaultValues,
			loading,
			setUser,
			setCompanies,
			setAuth,
			setCsrfToken,
			setDefaultVal,
			hydrate,
			logout_local
		}} >
			{props.children}
		</AppContext.Provider >
	)
}

export default State
